module.exports = __webpack_public_path__ + "img/LV40103429440.20fd39ab.png";